import {
  Component,
  ViewEncapsulation,
} from "@angular/core";

@Component({
  selector: "app-webpage-analytics",
  templateUrl: "./webpage-analytics.component.html",
  styleUrls: ["./webpage-analytics.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class WebpageAnalyticsComponent {
  constructor(
  ) {}
}
